function resolveWsUrl(url: string) {
  return url.replace(/^http(s)?/, 'ws$1')
}

export default resolveWsUrl
